import React from 'react';
import PropTypes from 'prop-types';
import { directionMap } from './styles';

export const SvgChevron = ({ width, height, stroke, direction }) => (
  <svg
    width={width || '6px'}
    height={height || '10px'}
    viewBox="0 0 6 10"
    version="1.1"
    style={{ transform: `rotate(${directionMap[direction]}deg)` }}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g transform="translate(-191.000000, -216.000000)" stroke={stroke} strokeWidth="2">
        <g transform="translate(182.000000, 209.000000)">
          <polyline points="14 16 10 12 14 8" />
        </g>
      </g>
    </g>
  </svg>
);

SvgChevron.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  direction: PropTypes.string,
};

SvgChevron.defaultProps = {
  stroke: '#000000',
  direction: 'left',
};
